import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  HostListener,
  EventEmitter,
  Output,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatGridListModule } from '@angular/material/grid-list';
import { ChatService } from '../../services/chat.service';
import { MessageTimestampComponent } from '../common/message-timestamp/message-timestamp.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { getYouTubeEmbedUrl, isYouTubeVideo } from '../../utils/helper';
import { MESSAGE_UNREAD_TEXT } from '../../utils/constants';

@Component({
  selector: 'app-dynamic-gallery',
  templateUrl: './dynamic-gallery.component.html',
  styleUrls: ['./dynamic-gallery.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    FormsModule,
    MatGridListModule,
    MatCardModule,
    MatChipsModule,
    MessageTimestampComponent,
  ],
  standalone: true,
})
export class DynamicGalleryComponent implements OnInit {
  @Input() input: any;
  @Input() isRead: boolean = false;
  config: any;
  messageUnreadText: string = MESSAGE_UNREAD_TEXT;
  @ViewChild('galleryContainer') galleryContainer!: ElementRef;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  isDragging = false;
  startX = 0;
  scrollLeft = 0;

  ngOnInit() {
    this.config = this.input?.config;

    if (this.config) {
      const { gallery_items } = this.config;
      if (gallery_items) {
        gallery_items.forEach((item: any) => {
          if (item.sub_title)
            item.sub_title = item.sub_title.replaceAll('\n', '<br>');
          if (item.title) item.title = item.title.replaceAll('\n', '<br>');
        });
      }
    }
  }

  constructor(
    private chatService: ChatService,
    private sanitizer: DomSanitizer
  ) {}

  get configs() {
    return this.chatService.configs;
  }

  scroll(direction: 'left' | 'right') {
    const container = this.galleryContainer.nativeElement;
    const scrollAmount = 250;

    if (direction === 'left') {
      container.scrollLeft -= scrollAmount;
    } else if (direction === 'right') {
      container.scrollLeft += scrollAmount;
    }
  }

  @HostListener('wheel', ['$event'])
  onScroll(event: WheelEvent) {
    const container = this.galleryContainer.nativeElement;
    event.preventDefault();

    if (event.deltaY > 0) {
      container.scrollLeft += 100;
    } else {
      container.scrollLeft -= 100;
    }
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    const container = this.galleryContainer.nativeElement;
    this.startX = event.pageX - container.offsetLeft;
    this.scrollLeft = container.scrollLeft;
    container.style.userSelect = 'none';
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    const container = this.galleryContainer.nativeElement;
    const x = event.pageX - container.offsetLeft;
    const walk = (x - this.startX) * 1.5;
    container.scrollLeft = this.scrollLeft - walk;
  }

  @HostListener('mouseup')
  @HostListener('mouseleave')
  onMouseUp() {
    this.isDragging = false;
    const container = this.galleryContainer.nativeElement;
    container.style.removeProperty('user-select');
  }

  onGalleryButtonClick(galleryItem: any, button: any) {
    if (galleryItem.buttons_config?.active) {
      button.config.forEach((conf: any) => {
        if (conf.type === 'URL Link') {
          window.open(conf.link_url, conf.new_tab ? '_blank' : '_self');
        }
      });

      this.action.emit({
        type: 'Response',
        button_id: `${button.id}`,
        message_text: button.label,
        option: button,
        label: button.label,
        galleryItemId: galleryItem.id,
      });
    }
  }
  isYouTubeVideo(url: string): boolean {
    return isYouTubeVideo(url);
  }

  getYouTubeEmbedUrl(url: string): SafeResourceUrl {
    const tempUrl = getYouTubeEmbedUrl(url);
    return this.sanitizer.bypassSecurityTrustResourceUrl(tempUrl);
  }
}
